import type { Apartment } from '../types';

/**
 * Czy kosz przy lokalu ma sens — lustro guardu `DELETE /api/apartments/:id` na danych, które widok
 * już ma. Backend odrzuca 409 APARTMENT_HAS_RECORDS lokal z JAKIMKOLWIEK zapisem kontroli (AIR);
 * `canonicalStatus` liczy backend z AIR BIEŻĄCEGO przeglądu (routes/buildings.js); lokal z zapisami tylko
 * z innych przeglądów dostaje `not_scheduled` (X11, 2026-10-19 — też niepusty), a bez AIR — legacy
 * `inspection_status` (completed/no_access/refused). Niepusty = lokal ma AIR ALBO legacy status wizyty:
 * AIR nigdy nie przecieknie (AIR.inspection_status jest NOT NULL), a nadmiarowa blokada dotyczy tylko
 * lokalu z legacy statusem bez AIR (na prod 2026-09-30: zero takich). Parytet z tabletem
 * (BuildingDetailsScreen: „Usuń" tylko przy lokalu bez wizyty — tam jeszcze ostrzej).
 *
 * Drugiego guardu (APARTMENT_IN_CEEB — lokal w bieżącym protokole CEEB, migr. 065) nie da się sprawdzić
 * z danych widoku; ten przypadek kończy się komunikatem 409 przy wierszu (z numerem protokołu).
 *
 * @returns powód blokady (tekst tooltipa) albo `null`, gdy lokal można próbować usunąć.
 */
export function apartmentDeleteBlockReason(apartment: Pick<Apartment, 'canonicalStatus'>): string | null {
  if (apartment.canonicalStatus != null && apartment.canonicalStatus !== '') {
    return 'Lokal ma zapis kontroli (wizyta, nieobecność albo dane z CEEB) — nie można go usunąć';
  }
  return null;
}
